/* unplugin-vue-components disabled */import script from "./pre-payment-price-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./pre-payment-price-modal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__